export enum BarDataType {
  Booking = "booking",
  EdgeStart = "edge-start",
  EdgeEnd = "edge-end",
  Engagement = "engagement",
  Role = "role",
  Row = "row",
  Misalignment = "misalignment",
  Overbookings = "overbookings"
}

export const BOOKING_DRAGGING_PLACEHOLDER_ATTRIBUTE = "data-booking-dragging-placeholder";
export const SPLIT_SEPARATOR_ATTRIBUTE = "data-split-separator";
